import { curry, prop } from 'ramda';

import { clear } from '../../../helpers/compact';
import { Link, LinkType } from '../../../types';
import { toDocType } from '../mapping';

const PRISMIC_LINK_TYPE = {
  WEB: 'Web',
  DOCUMENT: 'Document',
  MEDIA: 'Media',
};

export const toLink = (l: any): Link => {
  const { link_type: linkType, ...link } = l || {};
  if (PRISMIC_LINK_TYPE.WEB === linkType && link.url) {
    const { url, ...rest } = link;
    return clear({
      url,
      ...rest,
      linkType: LinkType.LINK_TYPE_WEB,
    });
  }

  if (PRISMIC_LINK_TYPE.MEDIA === linkType && link.url) {
    const { url, name, size, ...rest } = link;
    return clear({
      url,
      name,
      size,
      ...rest,
      linkType: LinkType.LINK_TYPE_MEDIA,
    });
  }

  if (PRISMIC_LINK_TYPE.DOCUMENT === linkType && link.id) {
    return clear({
      linkType: LinkType.LINK_TYPE_DOC,
      type: toDocType(link.type),
      id: link.id,
      lang: link.lang,
      uid: link.uid,
    });
  }

  return undefined;
};

export const toLinkFromProp = curry((p, val) => toLink(prop(p, val)));
